<template>
    <header id="siteHeader" ref="siteHeader" class="fixed-top">
        <div class="container">
            <nav class="navbar navbar-expand-lg stroke px-0">
                <button class="navbar-toggler  collapsed bg-gradient" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false"
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon fa icon-expand fa-bars"></span>
                    <span class="navbar-toggler-icon fa icon-close fa-times"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
                    <ul class="navbar-nav mx-lg-auto">
                        <li class="nav-item">
                            <a class="nav-link active" style="padding-left:5px;padding-right:5px;" href="/"><span style=" color: transparent; text-shadow: 0 0 0 #2864FF;">🏠</span>回首頁</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="/">最新消息</a>
                        </li>
                        <li class="nav-item dropdown" @mouseenter="hvr = 1" @mouseleave="hvr = 0">
                            <a class="nav-link dropdown-toggle" style="padding-left:5px;padding-right:5px;" href="javascript:;" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                本組介紹<i class="fa fa-caret-down"></i>
                            </a>
                            <div :class="`dropdown-menu menu-ci-md ${hvr == 1 ? 'show': ''}`" aria-labelledby="navbarDropdown" style="min-width: 8rem;">
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`importantBusiness`)" >重要業務</a>
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`tissue`)">組織架構</a>
                            </div>
                        </li>
                        <li class="nav-item dropdown" @mouseenter="hvr = 2" @mouseleave="hvr = 0">
                            <a class="nav-link dropdown-toggle" style="padding-left:5px;padding-right:5px;" href="javascript:;" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                校園安全科<i class="fa fa-caret-down"></i>
                            </a>
                            <div :class="`dropdown-menu menu-ci-md ${hvr == 2 ? 'show': ''}`" aria-labelledby="navbarDropdown" style="min-width: 8rem;">
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`position`, {title:`校園安全科`,dept:`校安科`})">業務職掌</a>
                                <!-- <a class="dropdown-item" href="javascript:;" @click="gotoView(`law`, {title:`校園安全科`,dept:`校安科`})">相關法規</a> -->
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`link`, {title:`校園安全科`,dept:`校安科`})">相關連結</a>
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`download`, {title:`校園安全科`,dept:`校安科`})">表單下載</a>
                                <a class="dropdown-item" href="/csrc">表報系統</a>
                            </div>
                        </li>
                        <li class="nav-item dropdown" @mouseenter="hvr = 3" @mouseleave="hvr = 0">
                            <!-- First Tier Drop Down -->
                            <a class="nav-link dropdown-toggle" style="padding-left:5px;padding-right:5px;" href="javascript:;" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true"  aria-expanded="false">
                                學生輔導科<i class="fa fa-caret-down"></i>
                            </a>
                            <div :class="`dropdown-menu menu-ci-md ${hvr == 3 ? 'show': ''}`" aria-labelledby="navbarDropdown" style="min-width: 8rem;">
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`position`, {title:`學生輔導科`,dept:`輔導科`})">業務職掌</a>
                                <!-- <a class="dropdown-item" href="javascript:;" @click="gotoView(`law`, {title:`學生輔導科`,dept:`輔導科`})">相關法規</a> -->
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`link`, {title:`學生輔導科`,dept:`輔導科`})">相關連結</a>
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`download`, {title:`學生輔導科`,dept:`輔導科`})">表單下載</a>
                            </div>
                        </li>
                        <li class="nav-item dropdown" @mouseenter="hvr = 4" @mouseleave="hvr = 0">
                            <a class="nav-link dropdown-toggle" style="padding-left:5px;padding-right:5px;" href="javascript:;" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true"  aria-expanded="false">
                                學生事務科<i class="fa fa-caret-down"></i>
                            </a>
                            <div :class="`dropdown-menu menu-ci-md ${hvr == 4 ? 'show': ''}`" aria-labelledby="navbarDropdown" style="min-width: 8rem;">
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`position`, {title:`學生事務科`,dept:`學務科`})">業務職掌</a>
                                <!-- <a class="dropdown-item" href="javascript:;" @click="gotoView(`law`, {title:`學生事務科`,dept:`學務科`})">相關法規</a> -->
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`link`, {title:`學生事務科`,dept:`學務科`})">相關連結</a>
                                <a class="dropdown-item" href="javascript:;" @click="gotoView(`download`, {title:`學生事務科`,dept:`學務科`})">表單下載</a>
                            </div>
                        </li>
                        <li class="nav-item " @mouseenter="hvr = 8" @mouseleave="hvr = 0">
                            <a @click="gotoView(`leaderTrainingCamp.index`)" class="nav-link " style="padding-left:5px;padding-right:5px;text-align: center;" href="javascript:;" >
                                新世紀領導<br />人才培育營
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </nav>
        </div>
    </header>
</template>
<script>
export default {
    data(){
        return {
            hvr:0
        }
    },
    mounted(){
        this.onScroll();
        window.addEventListener("scroll", this.onScroll);
    },
    methods:{
        onScroll(){
            let s = window.top.scrollY;
            if(document.querySelector("#siteHeader")){
            if(s >= 80){
                document.querySelector("#siteHeader").classList.add('nav-fixed');
            }else{
                document.querySelector("#siteHeader").classList.remove('nav-fixed');
            }
            }
        }
    }
}
</script>
<style>
@media screen and (min-width:900px) {
    .menu-ci-md{
        margin: -0.6rem 4.5rem 0rem;
    }
}
</style>